"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_grid_layout_1 = __importDefault(require("react-grid-layout"));
const classnames_1 = __importDefault(require("classnames"));
const card_container_1 = __importDefault(require("./card-container"));
const card_content_1 = __importDefault(require("./card-content"));
const card_content_mapper_1 = require("./card-content-mapper");
const helpers_1 = require("./helpers");
require("../../styles/components/grid-layout/grid-layout.less");
require("react-grid-layout/css/styles.css");
require("react-resizable/css/styles.css");
const GridLayout = (0, react_1.forwardRef)(({ cardsData, onExportCallback, gridSettings, onChange }, ref) => {
    const [activeCardId, setActiveCardId] = (0, react_1.useState)('');
    const [newCardsData, setNewCardsData] = (0, react_1.useState)(cardsData);
    const [canvasWidth, setCanvasWidth] = (0, react_1.useState)(1000);
    (0, react_1.useImperativeHandle)(ref, () => ({
        exportLayout() {
            onExportCallback(newCardsData);
        },
        addNewCard(cardType) {
            const emptyCardData = (0, card_content_mapper_1.getEmptyCardData)(cardType);
            setNewCardsData([...newCardsData, { ...emptyCardData }]);
        },
    }));
    (0, react_1.useEffect)(() => {
        if (cardsData) {
            setNewCardsData(cardsData);
        }
    }, [cardsData]);
    const updateCards = (0, react_1.useCallback)((cards) => {
        setNewCardsData(cards);
        if (onChange) {
            onChange(newCardsData);
        }
    }, [newCardsData, onChange]);
    const handleCanvasWidth = (0, react_1.useCallback)(() => {
        setCanvasWidth(window.innerWidth - 40);
        setNewCardsData((currentData) => {
            const newData = (0, card_content_mapper_1.fixCardSizesOnScreenResize)(currentData);
            if (onChange) {
                onChange(newData);
            }
            return newData;
        });
    }, [onChange]);
    (0, react_1.useLayoutEffect)(() => {
        // window resize listener
        window.addEventListener('resize', handleCanvasWidth);
        return () => window.removeEventListener('resize', handleCanvasWidth);
    }, [handleCanvasWidth]);
    const handleLayoutChange = (0, react_1.useCallback)((layouts) => {
        const cards = (0, helpers_1.updateCardsLayout)(layouts, newCardsData);
        updateCards(cards);
    }, [newCardsData, updateCards]);
    const handleCardUnselect = (0, react_1.useCallback)(() => {
        setActiveCardId('');
    }, []);
    const onDeleteCard = (0, react_1.useCallback)((cardId) => {
        updateCards(newCardsData.filter((card) => card.component?.id !== cardId));
    }, [newCardsData, updateCards]);
    const onDuplicateCard = (0, react_1.useCallback)((cardId) => {
        const cardData = (0, helpers_1.findCardById)(newCardsData, cardId);
        if (!cardData) {
            return;
        }
        const duplicateCard = (0, helpers_1.getDuplicateCardData)(cardData);
        updateCards([...newCardsData, { ...duplicateCard }]);
    }, [newCardsData, updateCards]);
    const cardsLayout = (0, react_1.useMemo)(() => newCardsData.map((card) => {
        const isActiveCard = card.component.id === activeCardId;
        return ({
            ...card.position,
            isResizable: isActiveCard,
            isDraggable: isActiveCard,
            resizeHandles: ['e', 's', 'w', 'n'],
        });
    }), [newCardsData, activeCardId]);
    const onCardActivated = (0, react_1.useCallback)((cardId) => {
        setActiveCardId(cardId);
    }, []);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('grid-layout', { empty: !cardsData.length }), onClick: handleCardUnselect },
        react_1.default.createElement(react_grid_layout_1.default, { cols: gridSettings?.cols, rowHeight: gridSettings?.rowHeight, layout: cardsLayout, width: canvasWidth, margin: gridSettings?.margin, onLayoutChange: handleLayoutChange, containerPadding: gridSettings?.containerPadding }, newCardsData.map(({ component: cardComponent }) => (react_1.default.createElement("div", { key: cardComponent?.id, className: (0, classnames_1.default)({ 'is-active': cardComponent?.id === activeCardId }) },
            react_1.default.createElement(card_container_1.default, { cardId: cardComponent?.id, updateActiveCard: onCardActivated, activeCardId: activeCardId, onDeleteCard: onDeleteCard, onDuplicateCard: onDuplicateCard },
                react_1.default.createElement(card_content_1.default, { cardComponent: cardComponent }))))))));
});
GridLayout.defaultProps = {
    ref: null,
    cardsData: [],
    onExportCallback: () => { },
    gridSettings: {
        cols: 12,
        rowHeight: 100,
        margin: [16, 16],
        containerPadding: [20, 20],
    },
    isEditMode: false,
};
exports.default = GridLayout;
//# sourceMappingURL=grid-layout.js.map